import { useEffect } from "react";
import { useAppDispatch } from "./redux";
import { fetchCreateOptions } from "@pages/videoCreating/videoCreatingSlice";
import { useSerializeCallback } from "@kalodata/tools";

export function useCreateVideoOptions(videoLanguage?: string) {
  const dispatch = useAppDispatch();

  const getOptions = useSerializeCallback(async () => {
    if (!videoLanguage) return;
    const options = await dispatch(fetchCreateOptions({ videoLanguage }));
    return options;
  });

  useEffect(() => {
    getOptions();
    // oxlint-disable-next-line eslint-plugin-react-hooks/exhaustive-deps
  }, [videoLanguage]);
}
